import React from 'react';

import { useModal } from '../../../../components/AlertModal/UniversalModal';

import { authService } from '../../../../services/authService';

import { useNavigate } from 'react-router-dom';

import { Nav } from 'react-bootstrap';

import share_icon from '../../../../img/share.svg';



const ExitFromEdit = ({ privilegedUser, exitFromEdit }) => {

    
    const {
        modalProps,
        alert,
        confirm,
        Modal
    } = useModal();


    const handleConfirm = async () => {

 
        const result = await confirm('Вийти з режиму редагування садочку?');

        if (result.button === 'Підтвердити') {
            const firstPage = await authService.returnToMainRole(privilegedUser);
            if(!firstPage) return alert('Виникла помилка, спробуйте пізнійше');
            return navigate(firstPage,  { replace: true });
        } else {
        console.log('Користувач скасував дію');
        }
    };

    const navigate = useNavigate();

    const onExitMenu = ()=>{
       
            handleConfirm();
    }


    if(!exitFromEdit) return <></>

    return(
        <>
          <div className="nav-divider"></div>
          {exitFromEdit.filter(m=>(!m.hasOwnProperty("active") || (m.active))).map(link=>(
              <div className="knowledge-base" key={link.id}>
                <Nav.Link 
                  href="1"
                  className="knowledge-link"
                  onClick={(e) => {
                    e.preventDefault();
                    
                    onExitMenu(link.id);
                    
                  }}
                >
                  {link.icon && <img src={link.icon} alt={link.label} className="nav-icon" />}
                  <span>{link.label}</span>
                  <img src={share_icon} alt="Share" className="nav-icon-share ms-2" />
                </Nav.Link>
              </div>
          ))}

          <Modal />

        </>
    )
    
};

export default ExitFromEdit;